import React, { useEffect, useRef } from "react";
import useVideoOrganiser from "./useVideoOrganiser/useVideoOrganiser";
import useAudioOrganiser from "./useAudioOrganiser/useAudioOrganiser";
import { handleNewPersonMagnitude } from "space/spaceSignalling";
import CamLoading from "graphics/icons/SideVideo/CamLoading";
import ScreenLoading from "graphics/icons/SideVideo/ScreenLoading";
import {
  GRID_VIEW,
  PINNED_CAMERA,
  PINNED_SHARE,
  SIDE_LARGE_VIEW,
  enlargeCamera,
  enlargeScreen,
  pinnedShareEnlarge,
} from "slices/spaceMediaSlice";
import Board from "../../../../Board/Board";

const VideoAudio = ({ person }) => {
  // window.efs_debug && window.log("VIDEO AUDIO RENDERED");
  const {
    luid,
    micOn,
    camOn,
    share,
    mutedForMe,
    muted,
    shout,
    pinnedShare,
    inRange,
    visual,
  } = person;
  const audElem = useRef();

  const shouldSeeShare =
    share &&
    (visual === PINNED_SHARE ||
      visual === PINNED_CAMERA ||
      visual === GRID_VIEW ||
      visual === SIDE_LARGE_VIEW);

  const shouldSeeCamera =
    camOn &&
    !(!inRange && pinnedShare && !shout) &&
    (visual === PINNED_SHARE ||
      visual === PINNED_CAMERA ||
      (visual === GRID_VIEW && !shouldSeeShare) ||
      (visual === SIDE_LARGE_VIEW && !shouldSeeShare));

  const shouldHearAudio = micOn && !mutedForMe && !muted && (inRange || shout);

  useAudioOrganiser(luid, shouldHearAudio);
  useVideoOrganiser(
    luid,
    shouldSeeShare && share === "screen",
    shouldSeeCamera,
    visual
  );

  useEffect(() => {
    if (pinnedShare) pinnedShareEnlarge(luid);
  }, [pinnedShare, luid]);

  return (
    <div id={`sideVideo${luid}`} className="video-wrapper">
      <video
        onLoadStart={() => {
          handleNewPersonMagnitude(luid);
        }}
        className={`camera ${visual === PINNED_SHARE ? "anchor-corner" : null}`}
        style={shouldSeeCamera ? null : { display: "none" }}
        onClick={visual === PINNED_SHARE ? () => enlargeCamera(luid) : null}
        autoPlay
        muted
        playsInline
        id={`remoteCamera${luid}`}
      ></video>
      <audio
        autoPlay
        playsInline
        ref={audElem}
        id={`remoteAudio${luid}`}
        onLoadStart={() => {
          handleNewPersonMagnitude(luid);
        }}
      />
      <div
        id={`remoteShare${luid}`}
        className={` remote-share ${
          visual === PINNED_CAMERA ? "anchor-corner" : ""
        }  ${shout ? "shouting-board" : ""} ${
          share === "board" ? "text-center" : ""
        }`}
        style={shouldSeeShare ? null : { display: "none" }}
        onClick={visual === PINNED_CAMERA ? () => enlargeScreen(luid) : null}
      >
        {share === "screen" ? (
          <video
            onLoadStart={() => {
              handleNewPersonMagnitude(luid);
            }}
            className={`screen  ${
              visual === PINNED_SHARE || visual === GRID_VIEW
                ? "show-completely"
                : "fill"
            }`}
            autoPlay
            muted
            playsInline
            id={`remoteScreen${luid}`}
          ></video>
        ) : share === "board" ? (
          <div
            className={`board-container ${
              shout || pinnedShare ? "shouting-board" : ""
            }`}
          >
            <Board luid={luid} person={person} />
          </div>
        ) : null}
      </div>

      {shouldSeeCamera || (shouldSeeShare && share === "screen") ? (
        <div className="video-loading">
          {shouldSeeCamera && visual !== PINNED_SHARE ? (
            <CamLoading />
          ) : (
            <ScreenLoading />
          )}
        </div>
      ) : null}
    </div>
  );
};
export default VideoAudio;
